import './top.css';
import { Header } from '../header/header';
import { Footer } from '../footer/footer';
import { useState, useEffect} from "react";

export const Top = () => {
  const [topMessage, setTopMessage] = useState<number>(1);
  useEffect(() => {
    const intervalId = setInterval(() => {
      setTopMessage((prevPage) => 0);
    }, 6000);

    return () => clearInterval(intervalId); 
  }, []); 

  return (
    <>
      <Header />
      <main>
          <div className='top-container'>
            {/* <div className='top-img-header'>
              <img src='img/top-bg.png' />
            </div> */}
            <div className='top-contents'>
              <h3 className='f-color-base'>ものづくりの喜びを、あなたと共に</h3>
              <p>革小物メーカーとしては国内最大規模のサンプル室を持つ、OEM生産のプロフェッショナルです。</p>
              <p>20〜70代という幅広い年代の職人が、どんなご依頼にも真摯に対応いたします。</p>
              <p>ときどき顔を見たくなる職人、ふっと立ち寄りたくなる製作所、そんな身近な存在でありたいと願っています。</p>
            </div>
            <div className='top-img-footer'>
              <img src='img/top-bg-footer.png' />
            </div>            
          </div>
        
      </main>        
      <Footer />
    </>
  );
};
